/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

// TODO: Separate into weather, bing

interface CenterOpts {
  lat: number;
  lng: number;
}
export const weather = (
  st: SpanTag,
  center: CenterOpts,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/weather?lat=${center.lat}&lng=${center.lng}`;
  return fetchAPI(stleaf(st, 'ula6ta'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

/**
 * Get up to date bing URL as required by Microsoft license
 * https://docs.microsoft.com/en-us/bingmaps/articles/bing-maps-tile-system
 */
export const bing = (st: SpanTag): Promise<APIResponse<string[]>> => {
  const url = `${config.API_URL}/v1/bing`;
  return fetchAPI(stleaf(st, 'gar3bo'), url, {
    method: 'GET',
    credentials: 'include',
    headers: headers,
  });
};
